import { render, staticRenderFns } from "./statusDotsIcon.vue?vue&type=template&id=13bc7d88&"
import script from "./statusDotsIcon.vue?vue&type=script&lang=js&"
export * from "./statusDotsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports